import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { transformToMenuSections } from "../../../../adapters/function-to-menu.adapter";
import { useFunctions } from "../../../../hooks/use-query-functions";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { classNames } from "primereact/utils";

const MenuItems = () => {
  const { data: functions, isLoading } = useFunctions({ limit: 100, sortBy: "order", sortOrder: "asc" } as BaseInputFilter);
  const [sections, setSections] = useState<any[]>([]);
  const [expandedKeys, setExpandedKeys] = useState<{ [key: string]: boolean }>({});
  const { userPermissions } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (functions?.data) {
      const transformed = transformToMenuSections(functions.data, userPermissions);
      setSections(transformed);
      // Initialize expanded state based on current route or default expanded
      const initialExpanded: { [key: string]: boolean } = {};
      transformed.forEach(sec => {
        const hasActiveChild = sec.items.some((item: any) => location.pathname.includes(item.path));
        initialExpanded[sec.label] = sec.expanded || hasActiveChild;
      });
      setExpandedKeys(initialExpanded);
    }
  }, [functions?.data, userPermissions, location.pathname]);

  const toggleSection = (label: string) => {
    setExpandedKeys(prev => ({ ...prev, [label]: !prev[label] }));
  };

  if (isLoading) return <p className="p-3 text-color-secondary">Carregando menu...</p>;

  return (
    <div className="flex flex-column gap-1 px-3 w-full">
      {sections.map((section) => {
        const isExpanded = expandedKeys[section.label];
        return (
          <div key={section.label} className="flex flex-column mb-1">
            <div 
              onClick={() => toggleSection(section.label)}
              className={classNames(
                "flex align-items-center p-2 border-round cursor-pointer transition-colors transition-duration-150 select-none",
                {
                  "surface-hover text-primary font-semibold": isExpanded,
                  "text-color hover:surface-hover": !isExpanded
                }
              )}
            >
              <i className={`${section.icon} mr-2`} style={{ fontSize: '1.1rem' }}></i>
              <span className="flex-1 text-sm">{section.label}</span>
              <i className={classNames("pi text-xs transition-transform transition-duration-200", {
                "pi-chevron-down": isExpanded,
                "pi-chevron-right": !isExpanded
              })}></i>
            </div>
            
            {/* SubItems Wrapper (Collapsible) */}
            {isExpanded && (
              <div className="flex flex-column gap-1 pl-4 mt-1">
                {section.items.map((item: any) => {
                  const isActive = location.pathname.includes(item.path);
                  return (
                    <div 
                      key={item.label}
                      onClick={() => navigate(item.path)}
                      className={classNames(
                        "flex align-items-center p-2 border-round cursor-pointer transition-colors transition-duration-150 select-none",
                        {
                          "surface-200 text-primary font-semibold": isActive,
                          "text-color-secondary hover:surface-hover hover:text-color": !isActive
                        }
                      )}
                    >
                      {item.icon && <i className={`${item.icon} mr-2`} style={{ fontSize: '0.9rem' }}></i>}
                      <span className="text-sm">{item.label}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MenuItems;
